/* eslint-disable react/jsx-no-target-blank */
import React from "react";

import HeaderSection from "./Header";
import FooterSection from "./Footer";
import Loader from "Components/Common/Loader";

import { useGetMenuItemsQuery } from "apis/HomePage";

const WaysToSaveMoney = () => {
  const { data: { data: menuItems = [] } = {}, isLoading: isMenuDataLoading } =
    useGetMenuItemsQuery();

  if (isMenuDataLoading) return <Loader />;

  return (
    <div className="d-flex flex-column justify-content-between min-vh-100">
      <div className="header-nav-wrapper nav-background">
        <div className="container-fluid">
          <HeaderSection menuItems={menuItems} isGiftInfo />
        </div>
      </div>

      <div
        className="container-fluid vision-section"
        style={{
          paddingTop: "130px",
          textAlign: "justify",
        }}
      >
        <h2 style={{ textAlign: "center" }}>
          <strong>Simple ways to Save Money</strong>
        </h2>
        <div className="ms-5 me-5 mt-4">
          <p>
            Find out how to make small changes in your life to save energy and
            reduce your electricity bills.
          </p>
          <p>
            The need for electricity is growing and will only get bigger in the
            future, therefore conserving energy is critical. Due to the finite
            nature of fossil fuel supplies, there is an overwhelming amount of
            pressure on the supply side to keep up with the growing demand for
            power. Major worldwide climate changes are currently being caused by
            the burning of coal in power plants, which produces the majority of
            our electricity.
          </p>
          <p>
            Go over these easy, common methods to preserve energy and the
            environment!
          </p>
          <div className="mt-5">
            <a
              className="text-decoration-underline cursor-pointer"
              href="https://utilities.giftgujarat.in/api/static/residential_tips.pdf"
              target="_blank"
            >
              Tips to Save Energy at Home
            </a>
          </div>
          <div className="mt-2">
            <a
              className="text-decoration-underline cursor-pointer"
              href="https://utilities.giftgujarat.in/api/static/green_building_tips.pdf"
              target="_blank"
            >
              Tips to Save Energy at Building
            </a>
          </div>
          <div className="mt-2">
            <a
              className="text-decoration-underline cursor-pointer"
              href="https://utilities.giftgujarat.in/api/static/Commercial_tips.pdf"
              target="_blank"
            >
              Tips to Save Energy at Workplace
            </a>
          </div>
        </div>
      </div>

      <FooterSection menuItems={menuItems} isGiftInfo />
    </div>
  );
};

export default WaysToSaveMoney;
